/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AlertsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getByUser(userId?: string | undefined, isAcknowledged?: boolean | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, paging_Page?: number | undefined, paging_PageSize?: number | undefined, sorting_OrderBy?: string | null | undefined, sorting_OrderByAsc?: boolean | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<PagedResultOfAlert>> {
        let url_ = this.baseUrl + "/byUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isAcknowledged !== undefined && isAcknowledged !== null)
            url_ += "IsAcknowledged=" + encodeURIComponent("" + isAcknowledged) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (paging_Page === null)
            throw new Error("The parameter 'paging_Page' cannot be null.");
        else if (paging_Page !== undefined)
            url_ += "Paging.Page=" + encodeURIComponent("" + paging_Page) + "&";
        if (paging_PageSize === null)
            throw new Error("The parameter 'paging_PageSize' cannot be null.");
        else if (paging_PageSize !== undefined)
            url_ += "Paging.PageSize=" + encodeURIComponent("" + paging_PageSize) + "&";
        if (sorting_OrderBy !== undefined && sorting_OrderBy !== null)
            url_ += "Sorting.OrderBy=" + encodeURIComponent("" + sorting_OrderBy) + "&";
        if (sorting_OrderByAsc === null)
            throw new Error("The parameter 'sorting_OrderByAsc' cannot be null.");
        else if (sorting_OrderByAsc !== undefined)
            url_ += "Sorting.OrderByAsc=" + encodeURIComponent("" + sorting_OrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetByUser(_response);
        });
    }

    protected processGetByUser(response: Response): Promise<SwaggerResponse<PagedResultOfAlert>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfAlert.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PagedResultOfAlert>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getBySite(siteId?: string | null | undefined, isAcknowledged?: boolean | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, paging_Page?: number | undefined, paging_PageSize?: number | undefined, sorting_OrderBy?: string | null | undefined, sorting_OrderByAsc?: boolean | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<PagedResultOfAlert>> {
        let url_ = this.baseUrl + "/bySite?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (isAcknowledged !== undefined && isAcknowledged !== null)
            url_ += "IsAcknowledged=" + encodeURIComponent("" + isAcknowledged) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (paging_Page === null)
            throw new Error("The parameter 'paging_Page' cannot be null.");
        else if (paging_Page !== undefined)
            url_ += "Paging.Page=" + encodeURIComponent("" + paging_Page) + "&";
        if (paging_PageSize === null)
            throw new Error("The parameter 'paging_PageSize' cannot be null.");
        else if (paging_PageSize !== undefined)
            url_ += "Paging.PageSize=" + encodeURIComponent("" + paging_PageSize) + "&";
        if (sorting_OrderBy !== undefined && sorting_OrderBy !== null)
            url_ += "Sorting.OrderBy=" + encodeURIComponent("" + sorting_OrderBy) + "&";
        if (sorting_OrderByAsc === null)
            throw new Error("The parameter 'sorting_OrderByAsc' cannot be null.");
        else if (sorting_OrderByAsc !== undefined)
            url_ += "Sorting.OrderByAsc=" + encodeURIComponent("" + sorting_OrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBySite(_response);
        });
    }

    protected processGetBySite(response: Response): Promise<SwaggerResponse<PagedResultOfAlert>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfAlert.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PagedResultOfAlert>>(new SwaggerResponse(status, _headers, <any>null));
    }

    acknowledgeByEmail(request: AcknowledgeRequestApiModel): Promise<SwaggerResponse<Alert>> {
        let url_ = this.baseUrl + "/AcknowledgeByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcknowledgeByEmail(_response);
        });
    }

    protected processAcknowledgeByEmail(response: Response): Promise<SwaggerResponse<Alert>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Alert.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Alert>>(new SwaggerResponse(status, _headers, <any>null));
    }

    acknowledge(id: string, note?: string | null | undefined, tenantId?: number | undefined, userId?: string | null | undefined): Promise<SwaggerResponse<Alert>> {
        let url_ = this.baseUrl + "/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (note !== undefined && note !== null)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userId": userId !== undefined && userId !== null ? "" + userId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcknowledge(_response);
        });
    }

    protected processAcknowledge(response: Response): Promise<SwaggerResponse<Alert>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Alert.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Alert>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAllActiveAlertsCount(userId?: string | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<number>> {
        let url_ = this.baseUrl + "/activeCount?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllActiveAlertsCount(_response);
        });
    }

    protected processGetAllActiveAlertsCount(response: Response): Promise<SwaggerResponse<number>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<number>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPerSiteAsCsv(siteId?: string | null | undefined, isAcknowledged?: boolean | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, paging_Page?: number | undefined, paging_PageSize?: number | undefined, sorting_OrderBy?: string | null | undefined, sorting_OrderByAsc?: boolean | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/bySite/csv?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (isAcknowledged !== undefined && isAcknowledged !== null)
            url_ += "IsAcknowledged=" + encodeURIComponent("" + isAcknowledged) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (paging_Page === null)
            throw new Error("The parameter 'paging_Page' cannot be null.");
        else if (paging_Page !== undefined)
            url_ += "Paging.Page=" + encodeURIComponent("" + paging_Page) + "&";
        if (paging_PageSize === null)
            throw new Error("The parameter 'paging_PageSize' cannot be null.");
        else if (paging_PageSize !== undefined)
            url_ += "Paging.PageSize=" + encodeURIComponent("" + paging_PageSize) + "&";
        if (sorting_OrderBy !== undefined && sorting_OrderBy !== null)
            url_ += "Sorting.OrderBy=" + encodeURIComponent("" + sorting_OrderBy) + "&";
        if (sorting_OrderByAsc === null)
            throw new Error("The parameter 'sorting_OrderByAsc' cannot be null.");
        else if (sorting_OrderByAsc !== undefined)
            url_ += "Sorting.OrderByAsc=" + encodeURIComponent("" + sorting_OrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "text/csv"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPerSiteAsCsv(_response);
        });
    }

    protected processGetPerSiteAsCsv(response: Response): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getAllAsCsv(userId?: string | null | undefined, isAcknowledged?: boolean | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, paging_Page?: number | undefined, paging_PageSize?: number | undefined, sorting_OrderBy?: string | null | undefined, sorting_OrderByAsc?: boolean | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/byUser/csv?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isAcknowledged !== undefined && isAcknowledged !== null)
            url_ += "IsAcknowledged=" + encodeURIComponent("" + isAcknowledged) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (paging_Page === null)
            throw new Error("The parameter 'paging_Page' cannot be null.");
        else if (paging_Page !== undefined)
            url_ += "Paging.Page=" + encodeURIComponent("" + paging_Page) + "&";
        if (paging_PageSize === null)
            throw new Error("The parameter 'paging_PageSize' cannot be null.");
        else if (paging_PageSize !== undefined)
            url_ += "Paging.PageSize=" + encodeURIComponent("" + paging_PageSize) + "&";
        if (sorting_OrderBy !== undefined && sorting_OrderBy !== null)
            url_ += "Sorting.OrderBy=" + encodeURIComponent("" + sorting_OrderBy) + "&";
        if (sorting_OrderByAsc === null)
            throw new Error("The parameter 'sorting_OrderByAsc' cannot be null.");
        else if (sorting_OrderByAsc !== undefined)
            url_ += "Sorting.OrderByAsc=" + encodeURIComponent("" + sorting_OrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "text/csv"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAsCsv(_response);
        });
    }

    protected processGetAllAsCsv(response: Response): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    testTwilioSmsAlert(): Promise<SwaggerResponse<AlertThreshold>> {
        let url_ = this.baseUrl + "/TestTwilioMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestTwilioSmsAlert(_response);
        });
    }

    protected processTestTwilioSmsAlert(response: Response): Promise<SwaggerResponse<AlertThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }

    testTwilioMessageByNumber(number?: string | undefined): Promise<SwaggerResponse<AlertThreshold>> {
        let url_ = this.baseUrl + "/TestTwilioMessageByNumber?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestTwilioMessageByNumber(_response);
        });
    }

    protected processTestTwilioMessageByNumber(response: Response): Promise<SwaggerResponse<AlertThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }

    testTwilioMmsMessageByNumber(number?: string | undefined): Promise<SwaggerResponse<AlertThreshold>> {
        let url_ = this.baseUrl + "/TestTwilioMmsMessageByNumber?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestTwilioMmsMessageByNumber(_response);
        });
    }

    protected processTestTwilioMmsMessageByNumber(response: Response): Promise<SwaggerResponse<AlertThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }

    testTwilioCallAlert(number?: string | undefined): Promise<SwaggerResponse<AlertThreshold>> {
        let url_ = this.baseUrl + "/TestTwilioCallByNumber?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestTwilioCallAlert(_response);
        });
    }

    protected processTestTwilioCallAlert(response: Response): Promise<SwaggerResponse<AlertThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getMessageHistory(date?: Date | null | undefined): Promise<SwaggerResponse<MessageResource[]>> {
        let url_ = this.baseUrl + "/MessageHistoryFromTwilio?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessageHistory(_response);
        });
    }

    protected processGetMessageHistory(response: Response): Promise<SwaggerResponse<MessageResource[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<MessageResource[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getCallHistory(date?: Date | null | undefined): Promise<SwaggerResponse<MessageResource[]>> {
        let url_ = this.baseUrl + "/CallHistoryFromTwilio?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCallHistory(_response);
        });
    }

    protected processGetCallHistory(response: Response): Promise<SwaggerResponse<MessageResource[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<MessageResource[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getFrequencyHighPriorityThreshold(tenantId?: number | undefined): Promise<SwaggerResponse<FrequencyHighPriorityThresholdApiModel>> {
        let url_ = this.baseUrl + "/FrequencyHighPriorityThreshold";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFrequencyHighPriorityThreshold(_response);
        });
    }

    protected processGetFrequencyHighPriorityThreshold(response: Response): Promise<SwaggerResponse<FrequencyHighPriorityThresholdApiModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrequencyHighPriorityThresholdApiModel.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FrequencyHighPriorityThresholdApiModel>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateAlertThresholds(model: FrequencyHighPriorityThresholdApiModel, tenantId?: number | undefined): Promise<SwaggerResponse<AlertThreshold>> {
        let url_ = this.baseUrl + "/FrequencyHighPriorityThreshold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAlertThresholds(_response);
        });
    }

    protected processUpdateAlertThresholds(response: Response): Promise<SwaggerResponse<AlertThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateSiteNameAlerts(alertsSiteChange: AlertsSiteChangeRequest, tenantId?: number | undefined): Promise<SwaggerResponse<AlertThreshold>> {
        let url_ = this.baseUrl + "/UpdateSiteAlerts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alertsSiteChange);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSiteNameAlerts(_response);
        });
    }

    protected processUpdateSiteNameAlerts(response: Response): Promise<SwaggerResponse<AlertThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class AlertSensorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(tenantId?: number | undefined): Promise<SwaggerResponse<AlertSensor[]>> {
        let url_ = this.baseUrl + "/AlertSensors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SwaggerResponse<AlertSensor[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertSensor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertSensor[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPaged(from?: Date | null | undefined, to?: Date | null | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | null | undefined, orderByAsc?: boolean | undefined, roles?: string[] | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<PagedResultOfAlertSensorDto>> {
        let url_ = this.baseUrl + "/AlertSensors/paged?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByAsc === null)
            throw new Error("The parameter 'orderByAsc' cannot be null.");
        else if (orderByAsc !== undefined)
            url_ += "OrderByAsc=" + encodeURIComponent("" + orderByAsc) + "&";
        if (roles !== undefined && roles !== null)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: Response): Promise<SwaggerResponse<PagedResultOfAlertSensorDto>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfAlertSensorDto.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PagedResultOfAlertSensorDto>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPagedAsCsv(from?: Date | null | undefined, to?: Date | null | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | null | undefined, orderByAsc?: boolean | undefined, roles?: string[] | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/AlertSensors/paged/csv?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByAsc === null)
            throw new Error("The parameter 'orderByAsc' cannot be null.");
        else if (orderByAsc !== undefined)
            url_ += "OrderByAsc=" + encodeURIComponent("" + orderByAsc) + "&";
        if (roles !== undefined && roles !== null)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPagedAsCsv(_response);
        });
    }

    protected processGetPagedAsCsv(response: Response): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getHistoryPaged(from?: Date | null | undefined, to?: Date | null | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | null | undefined, orderByAsc?: boolean | undefined, roles?: string[] | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<PagedResultOfAlertSensor>> {
        let url_ = this.baseUrl + "/AlertSensors/history/paged?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByAsc === null)
            throw new Error("The parameter 'orderByAsc' cannot be null.");
        else if (orderByAsc !== undefined)
            url_ += "OrderByAsc=" + encodeURIComponent("" + orderByAsc) + "&";
        if (roles !== undefined && roles !== null)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistoryPaged(_response);
        });
    }

    protected processGetHistoryPaged(response: Response): Promise<SwaggerResponse<PagedResultOfAlertSensor>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfAlertSensor.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PagedResultOfAlertSensor>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getHistoryPagedAsCsv(from?: Date | null | undefined, to?: Date | null | undefined, page?: number | undefined, pageSize?: number | undefined, orderBy?: string | null | undefined, orderByAsc?: boolean | undefined, roles?: string[] | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/AlertSensors/history/paged/export?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByAsc === null)
            throw new Error("The parameter 'orderByAsc' cannot be null.");
        else if (orderByAsc !== undefined)
            url_ += "OrderByAsc=" + encodeURIComponent("" + orderByAsc) + "&";
        if (roles !== undefined && roles !== null)
            roles && roles.forEach(item => { url_ += "roles=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistoryPagedAsCsv(_response);
        });
    }

    protected processGetHistoryPagedAsCsv(response: Response): Promise<SwaggerResponse<FileResponse>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class AlertsPumpsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAlertByPumpId(pumpId: string, tenantId?: number | undefined): Promise<SwaggerResponse<AlertPump>> {
        let url_ = this.baseUrl + "/alertspump/{pumpId}";
        if (pumpId === undefined || pumpId === null)
            throw new Error("The parameter 'pumpId' must be defined.");
        url_ = url_.replace("{pumpId}", encodeURIComponent("" + pumpId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlertByPumpId(_response);
        });
    }

    protected processGetAlertByPumpId(response: Response): Promise<SwaggerResponse<AlertPump>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertPump.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertPump>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateAlert(pumpId: string, tenantId?: number | undefined): Promise<SwaggerResponse<FileResponse | null>> {
        let url_ = this.baseUrl + "/alertspump/{pumpId}";
        if (pumpId === undefined || pumpId === null)
            throw new Error("The parameter 'pumpId' must be defined.");
        url_ = url_.replace("{pumpId}", encodeURIComponent("" + pumpId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PATCH",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAlert(_response);
        });
    }

    protected processUpdateAlert(response: Response): Promise<SwaggerResponse<FileResponse | null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse | null>>(new SwaggerResponse(status, _headers, <any>null));
    }

    createAlert(model: PumpAlertRequest, tenantId?: number | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/alertspump";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAlert(_response);
        });
    }

    protected processCreateAlert(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    acknowledgePumpByEmail(request: AcknowledgeRequestApiModel): Promise<SwaggerResponse<AlertPump>> {
        let url_ = this.baseUrl + "/alertspump/AcknowledgeByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcknowledgePumpByEmail(_response);
        });
    }

    protected processAcknowledgePumpByEmail(response: Response): Promise<SwaggerResponse<AlertPump>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertPump.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertPump>>(new SwaggerResponse(status, _headers, <any>null));
    }

    acknowledgePump(id: string, note?: string | null | undefined, tenantId?: number | undefined, userId?: string | null | undefined): Promise<SwaggerResponse<AlertPump>> {
        let url_ = this.baseUrl + "/alertspump/Acknowledge/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (note !== undefined && note !== null)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userId": userId !== undefined && userId !== null ? "" + userId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcknowledgePump(_response);
        });
    }

    protected processAcknowledgePump(response: Response): Promise<SwaggerResponse<AlertPump>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertPump.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertPump>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getPumpAlerts(userId?: string | undefined, isAcknowledged?: boolean | null | undefined, from?: Date | null | undefined, to?: Date | null | undefined, paging_Page?: number | undefined, paging_PageSize?: number | undefined, sorting_OrderBy?: string | null | undefined, sorting_OrderByAsc?: boolean | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<PagedResultOfAlertPump>> {
        let url_ = this.baseUrl + "/alertspump/alerts?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isAcknowledged !== undefined && isAcknowledged !== null)
            url_ += "IsAcknowledged=" + encodeURIComponent("" + isAcknowledged) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (paging_Page === null)
            throw new Error("The parameter 'paging_Page' cannot be null.");
        else if (paging_Page !== undefined)
            url_ += "Paging.Page=" + encodeURIComponent("" + paging_Page) + "&";
        if (paging_PageSize === null)
            throw new Error("The parameter 'paging_PageSize' cannot be null.");
        else if (paging_PageSize !== undefined)
            url_ += "Paging.PageSize=" + encodeURIComponent("" + paging_PageSize) + "&";
        if (sorting_OrderBy !== undefined && sorting_OrderBy !== null)
            url_ += "Sorting.OrderBy=" + encodeURIComponent("" + sorting_OrderBy) + "&";
        if (sorting_OrderByAsc === null)
            throw new Error("The parameter 'sorting_OrderByAsc' cannot be null.");
        else if (sorting_OrderByAsc !== undefined)
            url_ += "Sorting.OrderByAsc=" + encodeURIComponent("" + sorting_OrderByAsc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPumpAlerts(_response);
        });
    }

    protected processGetPumpAlerts(response: Response): Promise<SwaggerResponse<PagedResultOfAlertPump>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfAlertPump.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<PagedResultOfAlertPump>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class AlertThresholdsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getBySiteId(siteId?: string | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<AlertThresholdResponse[]>> {
        let url_ = this.baseUrl + "/thresholds/alert?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBySiteId(_response);
        });
    }

    protected processGetBySiteId(response: Response): Promise<SwaggerResponse<AlertThresholdResponse[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertThresholdResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThresholdResponse[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    createAlertThreshold(model: CreateAlertThresholdApiModel, tenantId?: number | undefined): Promise<SwaggerResponse<AlertThreshold>> {
        let url_ = this.baseUrl + "/thresholds/alert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAlertThreshold(_response);
        });
    }

    protected processCreateAlertThreshold(response: Response): Promise<SwaggerResponse<AlertThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateAlertThresholds(model: UpdateAlertThresholdApiModel, tenantId?: number | undefined): Promise<SwaggerResponse<AlertThreshold>> {
        let url_ = this.baseUrl + "/thresholds/alert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAlertThresholds(_response);
        });
    }

    protected processUpdateAlertThresholds(response: Response): Promise<SwaggerResponse<AlertThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }

    deleteById(id?: string | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/thresholds/alert?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, <any>null);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getBySiteIds(siteIds?: string[] | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<AlertThreshold[]>> {
        let url_ = this.baseUrl + "/thresholds/alert/many?";
        if (siteIds === null)
            throw new Error("The parameter 'siteIds' cannot be null.");
        else if (siteIds !== undefined)
            siteIds && siteIds.forEach(item => { url_ += "siteIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBySiteIds(_response);
        });
    }

    protected processGetBySiteIds(response: Response): Promise<SwaggerResponse<AlertThreshold[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertThreshold.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AlertThreshold[]>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class GlobalThresholdsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllThresholds(tenantId?: number | undefined): Promise<SwaggerResponse<GlobalThreshold>> {
        let url_ = this.baseUrl + "/thresholds/global";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllThresholds(_response);
        });
    }

    protected processGetAllThresholds(response: Response): Promise<SwaggerResponse<GlobalThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<GlobalThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }

    updateThresholds(model: UpdateGlobalThresholdApiModel, tenantId?: number | undefined, userEmail?: string | null | undefined): Promise<SwaggerResponse<ActionResultOfGlobalThreshold>> {
        let url_ = this.baseUrl + "/thresholds/global";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "userEmail": userEmail !== undefined && userEmail !== null ? "" + userEmail : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateThresholds(_response);
        });
    }

    protected processUpdateThresholds(response: Response): Promise<SwaggerResponse<ActionResultOfGlobalThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionResultOfGlobalThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ActionResultOfGlobalThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }

    deleteGlobalTelemetryThreshold(telemetryType?: string | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<ActionResultOfGlobalThreshold>> {
        let url_ = this.baseUrl + "/thresholds/global?";
        if (telemetryType !== undefined && telemetryType !== null)
            url_ += "telemetryType=" + encodeURIComponent("" + telemetryType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteGlobalTelemetryThreshold(_response);
        });
    }

    protected processDeleteGlobalTelemetryThreshold(response: Response): Promise<SwaggerResponse<ActionResultOfGlobalThreshold>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionResultOfGlobalThreshold.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ActionResultOfGlobalThreshold>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class LastProcessedTelemetryCacheClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCacheStats(): Promise<SwaggerResponse<CacheStats>> {
        let url_ = this.baseUrl + "/lastProcessedTelemetryCache/stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCacheStats(_response);
        });
    }

    protected processGetCacheStats(response: Response): Promise<SwaggerResponse<CacheStats>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CacheStats.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<CacheStats>>(new SwaggerResponse(status, _headers, <any>null));
    }

    getCacheItems(siteId?: string | null | undefined, assetId?: string | null | undefined, tenantId?: number | undefined, telemetryType?: string | null | undefined): Promise<SwaggerResponse<TelemetryMessage[]>> {
        let url_ = this.baseUrl + "/lastProcessedTelemetryCache/items?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (telemetryType !== undefined && telemetryType !== null)
            url_ += "telemetryType=" + encodeURIComponent("" + telemetryType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCacheItems(_response);
        });
    }

    protected processGetCacheItems(response: Response): Promise<SwaggerResponse<TelemetryMessage[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TelemetryMessage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<TelemetryMessage[]>>(new SwaggerResponse(status, _headers, <any>null));
    }

    delete(siteId?: string | null | undefined, assetId?: string | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<FileResponse | null>> {
        let url_ = this.baseUrl + "/lastProcessedTelemetryCache/items?";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        if (assetId !== undefined && assetId !== null)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "tenantId": tenantId !== undefined && tenantId !== null ? "" + tenantId : "",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<SwaggerResponse<FileResponse | null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse | null>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class VoiceTwilioClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    call(alertId?: string | null | undefined, userId?: string | null | undefined, message?: string | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<FileResponse | null>> {
        let url_ = this.baseUrl + "/VoiceTwilio/call?";
        if (alertId !== undefined && alertId !== null)
            url_ += "alertId=" + encodeURIComponent("" + alertId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCall(_response);
        });
    }

    protected processCall(response: Response): Promise<SwaggerResponse<FileResponse | null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse | null>>(new SwaggerResponse(status, _headers, <any>null));
    }

    show(digits?: string | null | undefined, alertId?: string | null | undefined, userId?: string | null | undefined, tenantId?: number | undefined): Promise<SwaggerResponse<FileResponse | null>> {
        let url_ = this.baseUrl + "/VoiceTwilio/show?";
        if (digits !== undefined && digits !== null)
            url_ += "digits=" + encodeURIComponent("" + digits) + "&";
        if (alertId !== undefined && alertId !== null)
            url_ += "alertId=" + encodeURIComponent("" + alertId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processShow(_response);
        });
    }

    protected processShow(response: Response): Promise<SwaggerResponse<FileResponse | null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse | null>>(new SwaggerResponse(status, _headers, <any>null));
    }

    callStatus(callStatus?: string | null | undefined, alertId?: string | null | undefined, userId?: string | null | undefined, tenantId?: string | null | undefined): Promise<SwaggerResponse<FileResponse | null>> {
        let url_ = this.baseUrl + "/VoiceTwilio/statusCallback?";
        if (callStatus !== undefined && callStatus !== null)
            url_ += "callStatus=" + encodeURIComponent("" + callStatus) + "&";
        if (alertId !== undefined && alertId !== null)
            url_ += "alertId=" + encodeURIComponent("" + alertId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallStatus(_response);
        });
    }

    protected processCallStatus(response: Response): Promise<SwaggerResponse<FileResponse | null>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<FileResponse | null>>(new SwaggerResponse(status, _headers, <any>null));
    }
}

export class PagedResultOfAlert {
    result?: Alert[] | undefined;
    count!: number;
    pageCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Alert.fromJS(item));
            }
            this.count = _data["count"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PagedResultOfAlert {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfAlert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageCount"] = this.pageCount;
        return data; 
    }
}

export class Alert {
    id?: string | undefined;
    assetId?: string | undefined;
    assetName?: string | undefined;
    siteId?: string | undefined;
    siteName?: string | undefined;
    telemetryType!: TelemetryType;
    previousTelemetryStatus!: TelemetryStatus;
    telemetryStatus!: TelemetryStatus;
    thresholdSource!: ThresholdSource;
    thresholdsType!: ThresholdsType;
    telemetryTimestamp!: Date;
    acknowledgement?: AlertAcknowledgement | undefined;
    insertedAt!: Date;
    previousTelemetryValue!: number;
    telemetryValue!: number;
    callsPerformed?: number | undefined;
    tenantId!: number;
    isHighPriority!: boolean;
    isHighPriorityAttended!: boolean;
    metaData?: MetaData | undefined;
    telemetryId?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.telemetryType = _data["telemetryType"];
            this.previousTelemetryStatus = _data["previousTelemetryStatus"];
            this.telemetryStatus = _data["telemetryStatus"];
            this.thresholdSource = _data["thresholdSource"];
            this.thresholdsType = _data["thresholdsType"];
            this.telemetryTimestamp = _data["telemetryTimestamp"] ? new Date(_data["telemetryTimestamp"].toString()) : <any>undefined;
            this.acknowledgement = _data["acknowledgement"] ? AlertAcknowledgement.fromJS(_data["acknowledgement"]) : <any>undefined;
            this.insertedAt = _data["insertedAt"] ? new Date(_data["insertedAt"].toString()) : <any>undefined;
            this.previousTelemetryValue = _data["previousTelemetryValue"];
            this.telemetryValue = _data["telemetryValue"];
            this.callsPerformed = _data["callsPerformed"];
            this.tenantId = _data["tenantId"];
            this.isHighPriority = _data["isHighPriority"];
            this.isHighPriorityAttended = _data["isHighPriorityAttended"];
            this.metaData = _data["metaData"] ? MetaData.fromJS(_data["metaData"]) : <any>undefined;
            this.telemetryId = _data["telemetryId"];
        }
    }

    static fromJS(data: any): Alert {
        data = typeof data === 'object' ? data : {};
        let result = new Alert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["telemetryType"] = this.telemetryType;
        data["previousTelemetryStatus"] = this.previousTelemetryStatus;
        data["telemetryStatus"] = this.telemetryStatus;
        data["thresholdSource"] = this.thresholdSource;
        data["thresholdsType"] = this.thresholdsType;
        data["telemetryTimestamp"] = this.telemetryTimestamp ? this.telemetryTimestamp.toISOString() : <any>undefined;
        data["acknowledgement"] = this.acknowledgement ? this.acknowledgement.toJSON() : <any>undefined;
        data["insertedAt"] = this.insertedAt ? this.insertedAt.toISOString() : <any>undefined;
        data["previousTelemetryValue"] = this.previousTelemetryValue;
        data["telemetryValue"] = this.telemetryValue;
        data["callsPerformed"] = this.callsPerformed;
        data["tenantId"] = this.tenantId;
        data["isHighPriority"] = this.isHighPriority;
        data["isHighPriorityAttended"] = this.isHighPriorityAttended;
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>undefined;
        data["telemetryId"] = this.telemetryId;
        return data; 
    }
}

export enum TelemetryType {
    TubingPressure = 1,
    CasingPressure = 2,
    TankLevel = 3,
    DiffPressure = 5,
    StaticPressure = 6,
    StaticTemp = 7,
    Flow = 8,
    GatewayMetrics = 9,
    SensorBatteryLevel = 10,
    HeaterTemp = 11,
    CrankRevolutions = 12,
    SeparatorPressure = 13,
    CompressorPressure = 14,
    PumpPressure = 15,
    LiquidFlow = 16,
    GasFlow = 17,
    StrokesPerMinute = 18,
    TemperaturePressure = 19,
    Vibration = 20,
    KnockoutPressure = 21,
    BalancedTank = 22,
    FlareStatus = 23,
    PumpControl = 24,
    GenericSensor = 999,
}

export enum TelemetryStatus {
    Undefined = 0,
    Green = 1,
    Yellow = 2,
    Red = 3,
}

export enum ThresholdSource {
    Undefined = 0,
    Site = 1,
    Global = 2,
}

export enum ThresholdsType {
    Telemetry = 0,
    RateOfChange = 1,
}

export class AlertAcknowledgement {
    userId?: string | undefined;
    userEmail?: string | undefined;
    timestamp!: Date;
    note?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AlertAcknowledgement {
        data = typeof data === 'object' ? data : {};
        let result = new AlertAcknowledgement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data; 
    }
}

export class MetaData {
    unitOfMeasure?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static fromJS(data: any): MetaData {
        data = typeof data === 'object' ? data : {};
        let result = new MetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitOfMeasure"] = this.unitOfMeasure;
        return data; 
    }
}

export class ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export class AcknowledgeRequestApiModel {
    token?: string | undefined;
    email?: string | undefined;
    note?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.email = _data["email"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AcknowledgeRequestApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new AcknowledgeRequestApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["email"] = this.email;
        data["note"] = this.note;
        return data; 
    }
}

export class AlertThreshold {
    id?: string | undefined;
    siteId?: string | undefined;
    siteName?: string | undefined;
    assetId?: string | undefined;
    assetName?: string | undefined;
    thresholdsType!: ThresholdsType;
    thresholds?: TelemetryThreshold[] | undefined;
    updatedAt?: Date | undefined;
    createdAt!: Date;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.thresholdsType = _data["thresholdsType"];
            if (Array.isArray(_data["thresholds"])) {
                this.thresholds = [] as any;
                for (let item of _data["thresholds"])
                    this.thresholds!.push(TelemetryThreshold.fromJS(item));
            }
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertThreshold {
        data = typeof data === 'object' ? data : {};
        let result = new AlertThreshold();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["thresholdsType"] = this.thresholdsType;
        if (Array.isArray(this.thresholds)) {
            data["thresholds"] = [];
            for (let item of this.thresholds)
                data["thresholds"].push(item.toJSON());
        }
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data; 
    }
}

export class TelemetryThreshold {
    name?: string | undefined;
    telemetryType!: TelemetryType;
    statusRanges?: StatusRange[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.telemetryType = _data["telemetryType"];
            if (Array.isArray(_data["statusRanges"])) {
                this.statusRanges = [] as any;
                for (let item of _data["statusRanges"])
                    this.statusRanges!.push(StatusRange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TelemetryThreshold {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryThreshold();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["telemetryType"] = this.telemetryType;
        if (Array.isArray(this.statusRanges)) {
            data["statusRanges"] = [];
            for (let item of this.statusRanges)
                data["statusRanges"].push(item.toJSON());
        }
        return data; 
    }
}

export class StatusRange {
    status!: TelemetryStatus;
    minThreshold!: number;
    maxThreshold!: number;
    isHighPriority!: boolean;
    allowPumpControl!: boolean;
    pumpsAssetsIdControlled?: string[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.minThreshold = _data["minThreshold"];
            this.maxThreshold = _data["maxThreshold"];
            this.isHighPriority = _data["isHighPriority"];
            this.allowPumpControl = _data["allowPumpControl"];
            if (Array.isArray(_data["pumpsAssetsIdControlled"])) {
                this.pumpsAssetsIdControlled = [] as any;
                for (let item of _data["pumpsAssetsIdControlled"])
                    this.pumpsAssetsIdControlled!.push(item);
            }
        }
    }

    static fromJS(data: any): StatusRange {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["minThreshold"] = this.minThreshold;
        data["maxThreshold"] = this.maxThreshold;
        data["isHighPriority"] = this.isHighPriority;
        data["allowPumpControl"] = this.allowPumpControl;
        if (Array.isArray(this.pumpsAssetsIdControlled)) {
            data["pumpsAssetsIdControlled"] = [];
            for (let item of this.pumpsAssetsIdControlled)
                data["pumpsAssetsIdControlled"].push(item);
        }
        return data; 
    }
}

export abstract class Resource {

    init(_data?: any) {
    }

    static fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Resource' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export class MessageResource extends Resource {
    /** The message text */
    body?: string | undefined;
    /** The number of messages used to deliver the message body */
    num_segments?: string | undefined;
    /** The direction of the message */
    direction?: DirectionEnum | undefined;
    /** The phone number that initiated the message */
    from?: PhoneNumber | undefined;
    /** The phone number that received the message */
    to?: string | undefined;
    /** The RFC 2822 date and time in GMT that the resource was last updated */
    date_updated?: Date | undefined;
    /** The amount billed for the message */
    price?: string | undefined;
    /** The description of the error_code */
    error_message?: string | undefined;
    /** The URI of the resource, relative to `https://api.twilio.com` */
    uri?: string | undefined;
    /** The SID of the Account that created the resource */
    account_sid?: string | undefined;
    /** The number of media files associated with the message */
    num_media?: string | undefined;
    /** The status of the message */
    status?: StatusEnum | undefined;
    /** The SID of the Messaging Service used with the message. */
    messaging_service_sid?: string | undefined;
    /** The unique string that identifies the resource */
    sid?: string | undefined;
    /** The RFC 2822 date and time in GMT when the message was sent */
    date_sent?: Date | undefined;
    /** The RFC 2822 date and time in GMT that the resource was created */
    date_created?: Date | undefined;
    /** The error code associated with the message */
    error_code?: number | undefined;
    /** The currency in which price is measured */
    price_unit?: string | undefined;
    /** The API version used to process the message */
    api_version?: string | undefined;
    /** A list of related resources identified by their relative URIs */
    subresource_uris?: { [key: string]: string; } | undefined;

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.body = _data["body"];
            this.num_segments = _data["num_segments"];
            this.direction = _data["direction"] ? DirectionEnum.fromJS(_data["direction"]) : <any>undefined;
            this.from = _data["from"] ? PhoneNumber.fromJS(_data["from"]) : <any>undefined;
            this.to = _data["to"];
            this.date_updated = _data["date_updated"] ? new Date(_data["date_updated"].toString()) : <any>undefined;
            this.price = _data["price"];
            this.error_message = _data["error_message"];
            this.uri = _data["uri"];
            this.account_sid = _data["account_sid"];
            this.num_media = _data["num_media"];
            this.status = _data["status"] ? StatusEnum.fromJS(_data["status"]) : <any>undefined;
            this.messaging_service_sid = _data["messaging_service_sid"];
            this.sid = _data["sid"];
            this.date_sent = _data["date_sent"] ? new Date(_data["date_sent"].toString()) : <any>undefined;
            this.date_created = _data["date_created"] ? new Date(_data["date_created"].toString()) : <any>undefined;
            this.error_code = _data["error_code"];
            this.price_unit = _data["price_unit"];
            this.api_version = _data["api_version"];
            if (_data["subresource_uris"]) {
                this.subresource_uris = {} as any;
                for (let key in _data["subresource_uris"]) {
                    if (_data["subresource_uris"].hasOwnProperty(key))
                        (<any>this.subresource_uris)![key] = _data["subresource_uris"][key];
                }
            }
        }
    }

    static fromJS(data: any): MessageResource {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        data["num_segments"] = this.num_segments;
        data["direction"] = this.direction ? this.direction.toJSON() : <any>undefined;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["to"] = this.to;
        data["date_updated"] = this.date_updated ? this.date_updated.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["error_message"] = this.error_message;
        data["uri"] = this.uri;
        data["account_sid"] = this.account_sid;
        data["num_media"] = this.num_media;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["messaging_service_sid"] = this.messaging_service_sid;
        data["sid"] = this.sid;
        data["date_sent"] = this.date_sent ? this.date_sent.toISOString() : <any>undefined;
        data["date_created"] = this.date_created ? this.date_created.toISOString() : <any>undefined;
        data["error_code"] = this.error_code;
        data["price_unit"] = this.price_unit;
        data["api_version"] = this.api_version;
        if (this.subresource_uris) {
            data["subresource_uris"] = {};
            for (let key in this.subresource_uris) {
                if (this.subresource_uris.hasOwnProperty(key))
                    (<any>data["subresource_uris"])[key] = this.subresource_uris[key];
            }
        }
        super.toJSON(data);
        return data; 
    }
}

/** Enum object for strings */
export abstract class StringEnum {

    init(_data?: any) {
    }

    static fromJS(data: any): StringEnum {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'StringEnum' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export class DirectionEnum extends StringEnum {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DirectionEnum {
        data = typeof data === 'object' ? data : {};
        let result = new DirectionEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

/** Phone number endpoint */
export class PhoneNumber {

    init(_data?: any) {
    }

    static fromJS(data: any): PhoneNumber {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export class StatusEnum extends StringEnum {

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): StatusEnum {
        data = typeof data === 'object' ? data : {};
        let result = new StatusEnum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export class FrequencyHighPriorityThresholdApiModel {
    thresholdFrequencyRed?: number | undefined;
    thresholdFrequencyYellow?: number | undefined;

    init(_data?: any) {
        if (_data) {
            this.thresholdFrequencyRed = _data["thresholdFrequencyRed"];
            this.thresholdFrequencyYellow = _data["thresholdFrequencyYellow"];
        }
    }

    static fromJS(data: any): FrequencyHighPriorityThresholdApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new FrequencyHighPriorityThresholdApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thresholdFrequencyRed"] = this.thresholdFrequencyRed;
        data["thresholdFrequencyYellow"] = this.thresholdFrequencyYellow;
        return data; 
    }
}

export class AlertsSiteChangeRequest {
    siteId?: string | undefined;
    oldSiteName?: string | undefined;
    newSiteName?: string | undefined;

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.oldSiteName = _data["oldSiteName"];
            this.newSiteName = _data["newSiteName"];
        }
    }

    static fromJS(data: any): AlertsSiteChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AlertsSiteChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["oldSiteName"] = this.oldSiteName;
        data["newSiteName"] = this.newSiteName;
        return data; 
    }
}

export class AlertSensor {
    id?: string | undefined;
    sensorId?: string | undefined;
    siteId?: string | undefined;
    siteName?: string | undefined;
    lat!: number;
    lon!: number;
    assetId?: string | undefined;
    assetName?: string | undefined;
    tenantId!: number;
    provisionDate!: Date;
    lastReportTime!: Date;
    lastBatteryLevel?: number | undefined;
    createdAt!: Date;
    telemetryId?: string | undefined;
    telemetryType!: TelemetryType;
    gatewayId?: string | undefined;
    isNotified!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sensorId = _data["sensorId"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.tenantId = _data["tenantId"];
            this.provisionDate = _data["provisionDate"] ? new Date(_data["provisionDate"].toString()) : <any>undefined;
            this.lastReportTime = _data["lastReportTime"] ? new Date(_data["lastReportTime"].toString()) : <any>undefined;
            this.lastBatteryLevel = _data["lastBatteryLevel"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.telemetryId = _data["telemetryId"];
            this.telemetryType = _data["telemetryType"];
            this.gatewayId = _data["gatewayId"];
            this.isNotified = _data["isNotified"];
        }
    }

    static fromJS(data: any): AlertSensor {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSensor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sensorId"] = this.sensorId;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["tenantId"] = this.tenantId;
        data["provisionDate"] = this.provisionDate ? this.provisionDate.toISOString() : <any>undefined;
        data["lastReportTime"] = this.lastReportTime ? this.lastReportTime.toISOString() : <any>undefined;
        data["lastBatteryLevel"] = this.lastBatteryLevel;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["telemetryId"] = this.telemetryId;
        data["telemetryType"] = this.telemetryType;
        data["gatewayId"] = this.gatewayId;
        data["isNotified"] = this.isNotified;
        return data; 
    }
}

export class PagedResultOfAlertSensorDto {
    result?: AlertSensorDto[] | undefined;
    count!: number;
    pageCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AlertSensorDto.fromJS(item));
            }
            this.count = _data["count"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PagedResultOfAlertSensorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfAlertSensorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageCount"] = this.pageCount;
        return data; 
    }
}

export class AlertSensorDto {
    id?: string | undefined;
    sensorId?: string | undefined;
    siteId?: string | undefined;
    siteName?: string | undefined;
    siteRegion?: string | undefined;
    siteField?: string | undefined;
    siteStatus?: string | undefined;
    lat!: number;
    lon!: number;
    assetId?: string | undefined;
    assetName?: string | undefined;
    provisionDate!: Date;
    lastReportTime!: Date;
    lastBatteryLevel?: number | undefined;
    createdAt!: Date;
    telemetryId?: string | undefined;
    telemetryType?: string | undefined;
    gatewayId?: string | undefined;
    isNotified!: boolean;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sensorId = _data["sensorId"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.siteRegion = _data["siteRegion"];
            this.siteField = _data["siteField"];
            this.siteStatus = _data["siteStatus"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.provisionDate = _data["provisionDate"] ? new Date(_data["provisionDate"].toString()) : <any>undefined;
            this.lastReportTime = _data["lastReportTime"] ? new Date(_data["lastReportTime"].toString()) : <any>undefined;
            this.lastBatteryLevel = _data["lastBatteryLevel"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.telemetryId = _data["telemetryId"];
            this.telemetryType = _data["telemetryType"];
            this.gatewayId = _data["gatewayId"];
            this.isNotified = _data["isNotified"];
        }
    }

    static fromJS(data: any): AlertSensorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSensorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sensorId"] = this.sensorId;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["siteRegion"] = this.siteRegion;
        data["siteField"] = this.siteField;
        data["siteStatus"] = this.siteStatus;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["provisionDate"] = this.provisionDate ? this.provisionDate.toISOString() : <any>undefined;
        data["lastReportTime"] = this.lastReportTime ? this.lastReportTime.toISOString() : <any>undefined;
        data["lastBatteryLevel"] = this.lastBatteryLevel;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["telemetryId"] = this.telemetryId;
        data["telemetryType"] = this.telemetryType;
        data["gatewayId"] = this.gatewayId;
        data["isNotified"] = this.isNotified;
        return data; 
    }
}

export class PagedResultOfAlertSensor {
    result?: AlertSensor[] | undefined;
    count!: number;
    pageCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AlertSensor.fromJS(item));
            }
            this.count = _data["count"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PagedResultOfAlertSensor {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfAlertSensor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageCount"] = this.pageCount;
        return data; 
    }
}

export class AlertPump {
    id?: string | undefined;
    siteId?: string | undefined;
    siteName?: string | undefined;
    assetName?: string | undefined;
    assetsId?: string[] | undefined;
    pumpDeviceId?: string | undefined;
    error?: string | undefined;
    alertType?: string | undefined;
    tenantId!: number;
    insertedAt!: Date;
    updatedAt!: Date;
    isActive?: boolean | undefined;
    acknowledgement?: AlertAcknowledgement | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.assetName = _data["assetName"];
            if (Array.isArray(_data["assetsId"])) {
                this.assetsId = [] as any;
                for (let item of _data["assetsId"])
                    this.assetsId!.push(item);
            }
            this.pumpDeviceId = _data["pumpDeviceId"];
            this.error = _data["error"];
            this.alertType = _data["alertType"];
            this.tenantId = _data["tenantId"];
            this.insertedAt = _data["insertedAt"] ? new Date(_data["insertedAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.acknowledgement = _data["acknowledgement"] ? AlertAcknowledgement.fromJS(_data["acknowledgement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertPump {
        data = typeof data === 'object' ? data : {};
        let result = new AlertPump();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["assetName"] = this.assetName;
        if (Array.isArray(this.assetsId)) {
            data["assetsId"] = [];
            for (let item of this.assetsId)
                data["assetsId"].push(item);
        }
        data["pumpDeviceId"] = this.pumpDeviceId;
        data["error"] = this.error;
        data["alertType"] = this.alertType;
        data["tenantId"] = this.tenantId;
        data["insertedAt"] = this.insertedAt ? this.insertedAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["acknowledgement"] = this.acknowledgement ? this.acknowledgement.toJSON() : <any>undefined;
        return data; 
    }
}

export class PumpAlertRequest {
    siteId?: string | undefined;
    error?: string | undefined;
    assetsId?: string[] | undefined;
    pumpDeviceId?: string | undefined;
    alertType!: PumpAlertType;
    insertedAt!: Date;
    updatedAt!: Date;

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.error = _data["error"];
            if (Array.isArray(_data["assetsId"])) {
                this.assetsId = [] as any;
                for (let item of _data["assetsId"])
                    this.assetsId!.push(item);
            }
            this.pumpDeviceId = _data["pumpDeviceId"];
            this.alertType = _data["alertType"];
            this.insertedAt = _data["insertedAt"] ? new Date(_data["insertedAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PumpAlertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PumpAlertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["error"] = this.error;
        if (Array.isArray(this.assetsId)) {
            data["assetsId"] = [];
            for (let item of this.assetsId)
                data["assetsId"].push(item);
        }
        data["pumpDeviceId"] = this.pumpDeviceId;
        data["alertType"] = this.alertType;
        data["insertedAt"] = this.insertedAt ? this.insertedAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data; 
    }
}

export enum PumpAlertType {
    PumpStatus = 0,
    PumpStatusChange = 1,
    PumpOffStatus = 2,
}

export class PagedResultOfAlertPump {
    result?: AlertPump[] | undefined;
    count!: number;
    pageCount!: number;

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AlertPump.fromJS(item));
            }
            this.count = _data["count"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): PagedResultOfAlertPump {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfAlertPump();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageCount"] = this.pageCount;
        return data; 
    }
}

export class AlertThresholdResponse {
    id?: string | undefined;
    siteId?: string | undefined;
    siteName?: string | undefined;
    assetId?: string | undefined;
    assetName?: string | undefined;
    thresholdsType!: ThresholdsType;
    thresholds?: TelemetryThresholdResponse[] | undefined;
    updatedAt?: Date | undefined;
    createdAt!: Date;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.thresholdsType = _data["thresholdsType"];
            if (Array.isArray(_data["thresholds"])) {
                this.thresholds = [] as any;
                for (let item of _data["thresholds"])
                    this.thresholds!.push(TelemetryThresholdResponse.fromJS(item));
            }
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertThresholdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AlertThresholdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["thresholdsType"] = this.thresholdsType;
        if (Array.isArray(this.thresholds)) {
            data["thresholds"] = [];
            for (let item of this.thresholds)
                data["thresholds"].push(item.toJSON());
        }
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data; 
    }
}

export class TelemetryThresholdResponse {
    telemetryType!: TelemetryType;
    statusRanges?: StatusRangeResponse[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.telemetryType = _data["telemetryType"];
            if (Array.isArray(_data["statusRanges"])) {
                this.statusRanges = [] as any;
                for (let item of _data["statusRanges"])
                    this.statusRanges!.push(StatusRangeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TelemetryThresholdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryThresholdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["telemetryType"] = this.telemetryType;
        if (Array.isArray(this.statusRanges)) {
            data["statusRanges"] = [];
            for (let item of this.statusRanges)
                data["statusRanges"].push(item.toJSON());
        }
        return data; 
    }
}

export class StatusRangeResponse {
    status!: TelemetryStatus;
    minThreshold!: number;
    maxThreshold!: number;
    isHighPriority!: boolean;
    allowPumpControl!: boolean;
    thresholdsType!: ThresholdsType;
    pumpsAssetsIdControlled?: string[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.minThreshold = _data["minThreshold"];
            this.maxThreshold = _data["maxThreshold"];
            this.isHighPriority = _data["isHighPriority"];
            this.allowPumpControl = _data["allowPumpControl"];
            this.thresholdsType = _data["thresholdsType"];
            if (Array.isArray(_data["pumpsAssetsIdControlled"])) {
                this.pumpsAssetsIdControlled = [] as any;
                for (let item of _data["pumpsAssetsIdControlled"])
                    this.pumpsAssetsIdControlled!.push(item);
            }
        }
    }

    static fromJS(data: any): StatusRangeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRangeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["minThreshold"] = this.minThreshold;
        data["maxThreshold"] = this.maxThreshold;
        data["isHighPriority"] = this.isHighPriority;
        data["allowPumpControl"] = this.allowPumpControl;
        data["thresholdsType"] = this.thresholdsType;
        if (Array.isArray(this.pumpsAssetsIdControlled)) {
            data["pumpsAssetsIdControlled"] = [];
            for (let item of this.pumpsAssetsIdControlled)
                data["pumpsAssetsIdControlled"].push(item);
        }
        return data; 
    }
}

export class CreateAlertThresholdApiModel {
    siteId!: string;
    siteName!: string;
    assetId!: string;
    assetName!: string;
    thresholdsType!: ThresholdsType;
    thresholds!: TelemetryThresholdApiModel[];

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.thresholdsType = _data["thresholdsType"];
            if (Array.isArray(_data["thresholds"])) {
                this.thresholds = [] as any;
                for (let item of _data["thresholds"])
                    this.thresholds!.push(TelemetryThresholdApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAlertThresholdApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlertThresholdApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["thresholdsType"] = this.thresholdsType;
        if (Array.isArray(this.thresholds)) {
            data["thresholds"] = [];
            for (let item of this.thresholds)
                data["thresholds"].push(item.toJSON());
        }
        return data; 
    }
}

export class TelemetryThresholdApiModel {
    telemetryType!: TelemetryType;
    statusRanges!: StatusRangeApiModel[];

    init(_data?: any) {
        if (_data) {
            this.telemetryType = _data["telemetryType"];
            if (Array.isArray(_data["statusRanges"])) {
                this.statusRanges = [] as any;
                for (let item of _data["statusRanges"])
                    this.statusRanges!.push(StatusRangeApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TelemetryThresholdApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryThresholdApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["telemetryType"] = this.telemetryType;
        if (Array.isArray(this.statusRanges)) {
            data["statusRanges"] = [];
            for (let item of this.statusRanges)
                data["statusRanges"].push(item.toJSON());
        }
        return data; 
    }
}

export class StatusRangeApiModel {
    status!: TelemetryStatus;
    minThreshold!: number;
    maxThreshold!: number;
    isHighPriority!: boolean;
    allowPumpControl!: boolean;
    pumpsAssetsIdControlled?: string[] | undefined;

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.minThreshold = _data["minThreshold"];
            this.maxThreshold = _data["maxThreshold"];
            this.isHighPriority = _data["isHighPriority"];
            this.allowPumpControl = _data["allowPumpControl"];
            if (Array.isArray(_data["pumpsAssetsIdControlled"])) {
                this.pumpsAssetsIdControlled = [] as any;
                for (let item of _data["pumpsAssetsIdControlled"])
                    this.pumpsAssetsIdControlled!.push(item);
            }
        }
    }

    static fromJS(data: any): StatusRangeApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusRangeApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["minThreshold"] = this.minThreshold;
        data["maxThreshold"] = this.maxThreshold;
        data["isHighPriority"] = this.isHighPriority;
        data["allowPumpControl"] = this.allowPumpControl;
        if (Array.isArray(this.pumpsAssetsIdControlled)) {
            data["pumpsAssetsIdControlled"] = [];
            for (let item of this.pumpsAssetsIdControlled)
                data["pumpsAssetsIdControlled"].push(item);
        }
        return data; 
    }
}

export class UpdateAlertThresholdApiModel {
    id!: string;
    siteId!: string;
    assetId!: string;
    thresholdsType!: ThresholdsType;
    thresholds!: TelemetryThresholdApiModel[];

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.assetId = _data["assetId"];
            this.thresholdsType = _data["thresholdsType"];
            if (Array.isArray(_data["thresholds"])) {
                this.thresholds = [] as any;
                for (let item of _data["thresholds"])
                    this.thresholds!.push(TelemetryThresholdApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateAlertThresholdApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlertThresholdApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["assetId"] = this.assetId;
        data["thresholdsType"] = this.thresholdsType;
        if (Array.isArray(this.thresholds)) {
            data["thresholds"] = [];
            for (let item of this.thresholds)
                data["thresholds"].push(item.toJSON());
        }
        return data; 
    }
}

export class GlobalThreshold {
    id?: string | undefined;
    thresholds?: TelemetryThreshold[] | undefined;
    thresholdsType!: ThresholdsType;
    updatedAt?: Date | undefined;
    createdAt!: Date;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["thresholds"])) {
                this.thresholds = [] as any;
                for (let item of _data["thresholds"])
                    this.thresholds!.push(TelemetryThreshold.fromJS(item));
            }
            this.thresholdsType = _data["thresholdsType"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GlobalThreshold {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalThreshold();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.thresholds)) {
            data["thresholds"] = [];
            for (let item of this.thresholds)
                data["thresholds"].push(item.toJSON());
        }
        data["thresholdsType"] = this.thresholdsType;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data; 
    }
}

export class ActionResultOfGlobalThreshold {
    result?: any | undefined;
    value?: GlobalThreshold | undefined;

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.value = _data["value"] ? GlobalThreshold.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActionResultOfGlobalThreshold {
        data = typeof data === 'object' ? data : {};
        let result = new ActionResultOfGlobalThreshold();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }
}

export class UpdateGlobalThresholdApiModel {
    telemetryType!: TelemetryType;
    statusRanges!: StatusRangeApiModel[];

    init(_data?: any) {
        if (_data) {
            this.telemetryType = _data["telemetryType"];
            if (Array.isArray(_data["statusRanges"])) {
                this.statusRanges = [] as any;
                for (let item of _data["statusRanges"])
                    this.statusRanges!.push(StatusRangeApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateGlobalThresholdApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGlobalThresholdApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["telemetryType"] = this.telemetryType;
        if (Array.isArray(this.statusRanges)) {
            data["statusRanges"] = [];
            for (let item of this.statusRanges)
                data["statusRanges"].push(item.toJSON());
        }
        return data; 
    }
}

export class CacheStats {
    totalItemsCount!: number;
    sitesCount!: number;

    init(_data?: any) {
        if (_data) {
            this.totalItemsCount = _data["totalItemsCount"];
            this.sitesCount = _data["sitesCount"];
        }
    }

    static fromJS(data: any): CacheStats {
        data = typeof data === 'object' ? data : {};
        let result = new CacheStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalItemsCount"] = this.totalItemsCount;
        data["sitesCount"] = this.sitesCount;
        return data; 
    }
}

export class TelemetryMessage {
    id?: string | undefined;
    brokerEventId?: string | undefined;
    gatewayId?: string | undefined;
    siteId?: string | undefined;
    assetId?: string | undefined;
    telemetryType!: TelemetryType;
    creationTimeUtc!: Date;
    payload?: any | undefined;
    customProperties?: { [key: string]: any; } | undefined;
    sensorId?: string | undefined;
    tenantId!: number;
    vendor?: string | undefined;
    isSimulated!: boolean;
    sensorBatteryLevel?: number | undefined;
    invalidData!: boolean;
    invalidDataDetails?: InvalidDataDetails | undefined;

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brokerEventId = _data["brokerEventId"];
            this.gatewayId = _data["gatewayId"];
            this.siteId = _data["siteId"];
            this.assetId = _data["assetId"];
            this.telemetryType = _data["telemetryType"];
            this.creationTimeUtc = _data["creationTimeUtc"] ? new Date(_data["creationTimeUtc"].toString()) : <any>undefined;
            this.payload = _data["payload"];
            if (_data["customProperties"]) {
                this.customProperties = {} as any;
                for (let key in _data["customProperties"]) {
                    if (_data["customProperties"].hasOwnProperty(key))
                        (<any>this.customProperties)![key] = _data["customProperties"][key];
                }
            }
            this.sensorId = _data["sensorId"];
            this.tenantId = _data["tenantId"];
            this.vendor = _data["vendor"];
            this.isSimulated = _data["isSimulated"];
            this.sensorBatteryLevel = _data["sensorBatteryLevel"];
            this.invalidData = _data["invalidData"];
            this.invalidDataDetails = _data["invalidDataDetails"] ? InvalidDataDetails.fromJS(_data["invalidDataDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TelemetryMessage {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brokerEventId"] = this.brokerEventId;
        data["gatewayId"] = this.gatewayId;
        data["siteId"] = this.siteId;
        data["assetId"] = this.assetId;
        data["telemetryType"] = this.telemetryType;
        data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : <any>undefined;
        data["payload"] = this.payload;
        if (this.customProperties) {
            data["customProperties"] = {};
            for (let key in this.customProperties) {
                if (this.customProperties.hasOwnProperty(key))
                    (<any>data["customProperties"])[key] = this.customProperties[key];
            }
        }
        data["sensorId"] = this.sensorId;
        data["tenantId"] = this.tenantId;
        data["vendor"] = this.vendor;
        data["isSimulated"] = this.isSimulated;
        data["sensorBatteryLevel"] = this.sensorBatteryLevel;
        data["invalidData"] = this.invalidData;
        data["invalidDataDetails"] = this.invalidDataDetails ? this.invalidDataDetails.toJSON() : <any>undefined;
        return data; 
    }
}

export class InvalidDataDetails {
    userEmail?: string | undefined;
    source!: InvalidDataSource;
    creationTimeUtc!: Date;

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["userEmail"];
            this.source = _data["source"];
            this.creationTimeUtc = _data["creationTimeUtc"] ? new Date(_data["creationTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvalidDataDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InvalidDataDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEmail"] = this.userEmail;
        data["source"] = this.source;
        data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : <any>undefined;
        return data; 
    }
}

export enum InvalidDataSource {
    OperationalParameters = 1,
    User = 2,
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}